import { createContext } from "react";

export const AuthContext = createContext({
    authToken: "",
    refreshToken: "",
    claims: null,
    isLoading: true,
    setAuthError: '',
    onLogin: () => { },
    onLogout: () => { },
});